/**
 * Parses database identifiers carried in route segments.
 *
 * Route ids are positive integers. Rejecting coercible forms such as `1.5`, `1e2`,
 * whitespace and zero keeps malformed links from silently becoming valid API requests.
 */
export function parsePositiveIntegerParam(value: string | undefined): number | null {
  if (value === undefined || !/^[1-9]\d*$/.test(value)) return null;

  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
}
